// Role helpers shared by the menu, routes and admin screens.
//
// CEDEX access mirrors the API (services/cedex_access.py): Admins, and users
// an Admin has granted the "CEDEX" role. The API is the real gate; these only
// decide what the UI offers.

export const CEDEX_ROLE = "CEDEX";

/** A user's roles as an array, whatever shape the token/user record has. */
export function userRoles(user) {
  if (Array.isArray(user?.roles)) return user.roles;
  if (typeof user?.roles === "string" && user.roles) return [user.roles];
  return [];
}

/** Metalytics' team (Admin, InternalUser): pick any company's project, see every user's items. */
export function isTeam(user) {
  const roles = userRoles(user);
  return roles.includes("Admin") || roles.includes("InternalUser");
}

export function hasCedexAccess(user) {
  const roles = userRoles(user);
  return roles.includes("Admin") || roles.includes(CEDEX_ROLE);
}

/** Role records sorted for display: case-insensitive by id, stable for ties. */
export function sortRoles(roles) {
  return [...(roles || [])].sort((a, b) =>
    String(a?.id ?? "").localeCompare(String(b?.id ?? ""), undefined, {
      sensitivity: "base",
      numeric: true,
    }),
  );
}
